import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { IImageEditorFirm } from './Entities';
import * as Actions from './actions/ImageEditorFirmsActions';
import ImageEditorFirmsList from './list/ImageEditorFirmsList';
import { Translate } from '../../shared/LanguageService';
import { Button, FormGroup, Checkbox } from 'react-bootstrap';
import { handleError } from '../../shared/ErrorCatching';
import notify from '../../shared/feedback/notifications';
import EditImageEditorFirmsModal from './modals/EditImageEditorFirmModal';
import CreateImageEditorFirmModal from './modals/CreateImageEditorFirmModal';

interface IState {
    showDiscontinued: boolean;
    showEditModal: boolean;
    showCreateModal: boolean;
    editFirmId: number;
}

interface IProps {
    imageEditorFirms: IImageEditorFirm[];
    actions: IActions;
}

class ImageEditorFirmsPage extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);

        this.state = {
            showEditModal: false,
            showCreateModal: false,
            editFirmId: 0,
            showDiscontinued: false
        };

        this.discontinued = this.discontinued.bind(this);
        this.onCheckboxChange = this.onCheckboxChange.bind(this);
    }

    componentDidMount() {
        this.props.actions.getImageEditorFirms();
    }

    onCloseEditModal = () => {
        this.setState({ editFirmId: 0, showEditModal: false });
    };

    onCloseCreateModal = () => {
        this.setState({ showCreateModal: false });
    };

    onClickCreateImageEditorFirm = () => {
        this.setState({ showCreateModal: true });
    };

    onClickEditImageEditorFirm = (id: number) => {
        this.setState({ editFirmId: id, showEditModal: true });
    };

    discontinued(id: number, isDiscontinued: number): void {
        this.props.actions.discontinued(id, isDiscontinued);
    }

    updateImageEditorFirm = (imageEditorFirm: IImageEditorFirm) => {
        if (imageEditorFirm) {
            this.props.actions
                .updateImageEditorFirm(imageEditorFirm)
                .then(() => {
                    this.props.actions.getImageEditorFirms();
                })
                .then(() => {
                    this.onCloseEditModal();
                    notify.success(
                        Translate('image-editor-firms/notification/image-editor-firm-updated')
                    );
                })
                .catch((error: unknown) => handleError(error));
        }
    };

    createImageEditorFirm = (imageEditorFirm: IImageEditorFirm) => {
        let { actions } = this.props;

        actions
            .addImageEditorFirm(imageEditorFirm)
            .then(() => {
                actions.getImageEditorFirms();
            })
            .then(() => {
                this.onCloseCreateModal();
                notify.success(
                    Translate('image-editor-firms/notification/image-editor-firm-added')
                );
            })
            .catch(handleError);
    };

    render() {
        let imageEditorFirms = this.props.imageEditorFirms;
        let showDiscontinued = this.state.showDiscontinued;

        if (!showDiscontinued) {
            imageEditorFirms = imageEditorFirms.filter((ImageEditorFirm: IImageEditorFirm) => {
                return !ImageEditorFirm.isDiscontinued;
            });
        }

        return (
            <div>
                <h1>{Translate('image-editor-firms/page/title/image-editor-firms')}</h1>
                <div className="col-md-3 no-label">
                    <FormGroup>
                        <Checkbox
                            className=""
                            name="showDiscontinued"
                            checked={this.state.showDiscontinued}
                            onChange={this.onCheckboxChange}
                        >
                            <span>
                                {Translate(
                                    'image-editor-firms/page/input-label/include-discontinued'
                                )}
                            </span>
                        </Checkbox>
                    </FormGroup>
                </div>
                <Button
                    bsSize="large"
                    className="pull-right"
                    onClick={this.onClickCreateImageEditorFirm}
                    bsStyle="success"
                >
                    {Translate('image-editor-firms/page/button-label/add-image-editor-firm')}
                </Button>
                {this.state.showEditModal ? (
                    <EditImageEditorFirmsModal
                        showModal={this.state.showEditModal}
                        onClose={this.onCloseEditModal}
                        editFirmId={this.state.editFirmId}
                        onSave={this.updateImageEditorFirm}
                    />
                ) : null}
                {this.state.showCreateModal ? (
                    <CreateImageEditorFirmModal
                        showModal={this.state.showCreateModal}
                        onClose={this.onCloseCreateModal}
                        onSave={this.createImageEditorFirm}
                    />
                ) : null}
                <ImageEditorFirmsList
                    imageEditorFirms={imageEditorFirms}
                    onClickEdit={this.onClickEditImageEditorFirm}
                    discontinued={this.discontinued}
                    showDiscontinued={this.state.showDiscontinued}
                />
            </div>
        );
    }

    onCheckboxChange() {
        this.setState({
            showDiscontinued: !this.state.showDiscontinued
        } as IState);
    }
}

interface IActions {
    getImageEditorFirms: () => Promise<any>;
    discontinued: (id: number, isDiscontinued: number) => Promise<any>;
    updateImageEditorFirm: (imageEditorFirm) => Promise<any>;
    addImageEditorFirm: (imageEditorFirm) => Promise<any>;
    getImageEditorFirm: (id: number) => Promise<any>;
}

function mapStateToProps(state: any, ownProps: any) {
    let imageEditorFirmsFromState: IImageEditorFirm[] = [...state.imageEditorFirms.list];
    let sortedList = imageEditorFirmsFromState.sort((a: IImageEditorFirm, b: IImageEditorFirm) => {
        return a.id - b.id;
    });
    return {
        imageEditorFirms: sortedList
    };
}

function mapDispatchToProps(dispatch: any): { actions: IActions } {
    return {
        actions: {
            getImageEditorFirms: () => dispatch(Actions.getImageEditorFirms()),
            discontinued: (id: number, isDiscontinued: number) =>
                dispatch(Actions.deleteImageEditorFirm(id, isDiscontinued)),
            addImageEditorFirm: (imageEditorFirm: IImageEditorFirm) =>
                dispatch(Actions.addImageEditorFirm(imageEditorFirm)),
            updateImageEditorFirm: (imageEditorFirm: IImageEditorFirm) =>
                dispatch(Actions.updateImageEditorFirm(imageEditorFirm)),
            getImageEditorFirm: (id: number) => dispatch(Actions.getImageEditorFirm(id))
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ImageEditorFirmsPage));
